import styled from "styled-components";

export const GameStyle = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    justify-content: center;
`;

export const ChessBoardContainer = styled.div`
   position: relative;
   width: 100%;
   max-width: 600px;
   overflow: hidden;
   margin: 0px auto;
`